<div class="filter">
    <div class="input-with-image">
        <img src="/assets/images/cards/search.svg">
        <input type="text" [formControl]="filter" placeholder="{{'search.searchSmartQuestions'| translate}}">
    </div>
</div>
<div class="warp-collection">
    <ng-container *ngIf="!loading$() else loading">
        <ng-container *ngIf="isExist$() else noQuestions">
            <div *ngFor="let que of collectionSig$()">
                <que-collection-item [question]="que" (chooseQuestionEmit)="chooseQuestion(que)"
                    (removeQuestionEmit)="removeQuestion(que)"></que-collection-item>
            </div>
        </ng-container>
    </ng-container>
</div>
<ng-template #noQuestions>
    <div *ngIf="isExistWithoutFilter$() else noExist">
        <p class="no-more">Smart Questions Not Found</p>
        <p class="no-more-mini">No results for "{{this.filter.value}}"</p>
    </div>
</ng-template>
<ng-template #noExist>
    <div>
        <p class="no-more">No Smart Questions </p>
    </div>
</ng-template>
<ng-template #loading>
    <div class="warp-mini-load">
        <div *ngFor="let _ of [].constructor(6)" class="loading-item load-enimation"> </div>
    </div>
</ng-template>